import {useThemeColors} from '@nfq/colors';

/**
 * The `useOptionItem` hook provides the appropriate color styling based on the active state of an option item.
 * It determines whether the item should be highlighted with the primary theme color or default text color.
 * This hook is useful for styling UI elements that need to visually indicate selection or focus state.
 *
 * @param isActive A boolean indicating whether the option item is currently active.
 * @returns An object containing:
 * - `colors`: The theme colors used for consistent UI styling.
 * - `itemColor`: The computed color for the option item, based on its active state.
 *
 * @example
 * ```tsx
 * const { itemColor } = useOptionItem(true);
 * console.log(itemColor); // Outputs the primary theme color
 * ```
 */
export const useOptionItem = (isActive: boolean) => {
    const colors = useThemeColors();
    const itemColor = isActive ? colors.primary : colors.textPrimary;

    return {
        colors,
        itemColor
    };
};